import EventBus from '@/event-bus'

export default {
  handle(topic) {
    console.log('timzone updated.....', topic)
    EventBus.$emit('timezones-updated')
  },
}
